import { render, staticRenderFns } from "./CustomChipsGroup.vue?vue&type=template&id=90ba8a66&scoped=true"
import script from "./CustomChipsGroup.vue?vue&type=script&lang=js"
export * from "./CustomChipsGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomChipsGroup.vue?vue&type=style&index=0&id=90ba8a66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba8a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90ba8a66')) {
      api.createRecord('90ba8a66', component.options)
    } else {
      api.reload('90ba8a66', component.options)
    }
    module.hot.accept("./CustomChipsGroup.vue?vue&type=template&id=90ba8a66&scoped=true", function () {
      api.rerender('90ba8a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomChipsGroup.vue"
export default component.exports